import script from "./zhaopin.vue?vue&type=script&setup=true&lang=js"
export * from "./zhaopin.vue?vue&type=script&setup=true&lang=js"

import "./zhaopin.vue?vue&type=style&index=0&id=3c837dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c837dd6"]])

export default __exports__